<template lang="pug">
div
  b-container
    b-button(v-if="hasActions() && isNotClosed" @click="showModal" size="sm")
      b-spinner(v-if="loading" small)
      span(v-else) Ver Acciones
    p(v-else) ---

    b-modal(v-model="modal" :title="modalTitle" @close="hideModal" hide-footer no-close-on-backdrop no-close-on-esc)
      div(v-if="loading" class="text-center my-3")
        b-spinner(label="Cargando acciones..." variant="primary")
      OTActionsIndex(
        v-else-if="ot"
        :ot="ot"
        squareLayout
        @changed="() => $emit('changed')"
      )
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import OTActionsIndex from '../OTActions/OTActionsIndex.vue'

export default {
  name: 'ActionsWrapper',
  data() {
    return {
      loading: false,
      modal: false,
      ot: null,
    }
  },

  props: {
    otId: {
      type: Number,
      required: true,
    },
    rma: {
      type: [String, Number],
      default: null,
    },
    actions: {
      type: Object,
      required: true,
      default: () => ({
        visible: [],
        disabled: [],
      }),
    },
    parentLoading: {
      type: Boolean,
      default: false,
    },
    isNotClosed: {
      type: Boolean,
      default: true,
    }
  },

  components: { OTActionsIndex },

  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
    modalTitle() {
      let title = `Acciones OT ${this.ot ? this.ot.ot : this.otId}`
      const rma = this.ot && this.ot.rma ? this.ot.rma : this.rma
      if (rma) {
        title += ` - RMA: ${rma}`
      }
      return title
    },
  },
  methods: {
    ...mapActions('OTStore', ['getOTForActions', 'cleanOT']),
    ...mapMutations('OT', ['SET_MODAL_ACTION', 'SET_IS_INITIAL_DATA']),
    // hasActions: (ot, user) => hasActions(ot, user),
    hasActions() {
      return (
        this.actions.visible.length > 0 ||
        this.actions.disabled.length > 0
      )
    },
    async showModal() {
      this.SET_MODAL_ACTION(true)
      this.modal = true
      this.fetchOT()
    },
    hideModal() {
      // Refresh silencioso: pedir actualización sólo de esta OT
      this.$emit('refresh-ot', this.otId)
      this.modal = false
      this.SET_MODAL_ACTION(false)
      // No cambiar el flag global de modo inicial aquí para evitar recargas completas
      this.cleanOT()
    },
    async fetchOT() {
      this.loading = true;
      this.ot = await this.getOTForActions(this.otId);
      this.loading = false;
    },
  },
  watch: {
    // otId() {
    //   this.fetchOT(this.otId);
    // },
  },
}
</script>
